import { AgentSupportedPropertyTypeEnum } from "@/api/generated";

export const buildSupportedPropertyTypeLabels = (
  supportedPropertyTypes?: AgentSupportedPropertyTypeEnum[] | null
): string[] => {
  const supported = supportedPropertyTypes ?? [];
  const orderedTypes = Object.values(AgentSupportedPropertyTypeEnum);
  const labels = orderedTypes.filter((type) => supported.includes(type));
  return labels.length > 0 ? labels : ["確認必要"];
};
